$(function () {
  function initDatePicker() {
    if ($.fn.datepicker) {
      document.querySelectorAll(".input__date-picker").forEach((element) => {
        const $datePicker = $(element);

        let options = {
          format: "yyyy-mm-dd",
          clearBtn: true,
          autoclose: true,
          todayHighlight: true,
          orientation: "auto bottom",
          zIndexOffset: 1000,
          container: $(element).closest(".form-group"),
        };

        const language = $datePicker.data("locale");

        if (language) {
          options.language = language;
        }

        const dateFormat = $datePicker.data("date-format");

        if (dateFormat) {
          options.format = dateFormat;
        }

        $datePicker.datepicker(options);
      });
    }
  }

  initDatePicker();
});
